import { useEffect } from 'react';
import { trackCustomerIOEvent } from 'utils/customerIO';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';
import { CustomerIOEvent } from 'lib/type';

const Adverts = () => {
    const translate = useTranslate('mainBanner');
    useEffect(() => {
        trackCustomerIOEvent(CustomerIOEvent.BANNER_INITIALIZE, {});
    }, []);

    return (
        <div className="adverts-container">
            <div id="bannerImage">
                <div className="banner-placeholder">
                    <Typography>{translate('title')}</Typography>
                </div>
            </div>
        </div>
    );
};

export default Adverts;
